import { faqList } from "@/mocks/anime";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Categories from "./components/Categories";
import NewSeason from "./components/NewSeason";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqList.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "小狗看番",
  url: "https://shsyyk.cn/",
  description: "专注搞笑番推荐、沙雕动画和解压爆笑日常合集的下饭神番聚合站。",
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <Hero />
      <Trending />
      <Categories />
      <NewSeason />
      <Reviews />
      <Faq />
      <About />
      <Footer />
      <BackToTop />
    </main>
  );
}